import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import styled from "styled-components";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType) => {
    if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.log(e);
      });
    }
  };

  return (
    <Button
      variant="secondary"
      className="ml-auto"
      onClick={() => handleLogin("redirect")}
    >
      Start
    </Button>
  );
};

const Button = styled.button`
  background-color: #ffffff;
  border: none;
  margin: 1em 0 0 0;
  border-radius: 8px;
  padding: 0.35em 1.25em 0.25em 1.25em;
`;
